import * as React from "react";
import {connect} from "react-redux";
import {isEmpty as _isEmpty} from "lodash"
import {ISymptom} from "@curefit/care-common";
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import SuggestionTagsContainer from "../../../containers/SuggestionTagsContainer";
import {SUB_SECTIONS_CONTEXT_KEY} from "../../../utils/AppConstants";
import IStaticDataValue from "../../../../../common/models/IStaticDataValue";
import {OngoingConsultationActions} from "../../../actions/OngoingConsultationActions";

/**
 * Created by aditya on 26/02/18.
 */

let PhysioComplaintsEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "concern", display: "CONCERN"},
    {label: "since", display: "SINCE"}
];


export interface PatientComplaintsEditorProps {
    updatedComplaints: {item: ISymptom}[],
    updateComplaints: (updatedSymptoms: {item: ISymptom}[]) => void,
    fetchStaticSymptoms: (input: string) => Promise<any>,
    suggestions: {[key: string]: any},
    addSymptomForReview: (symptom: string) => Promise<any>
}

class PatientComplaintsEditor extends React.Component<PatientComplaintsEditorProps> {

    constructor(props: PatientComplaintsEditorProps) {
        super(props);
    }

    onComplaintRemove = (index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedComplaints);
        currUpdatedSymptoms.splice(index, 1);
        this.props.updateComplaints(currUpdatedSymptoms);
    }

    onComplaintChange = (updatedSymptom: ISymptom, index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedComplaints);
        currUpdatedSymptoms[index] = updatedSymptom;
        this.props.updateComplaints(currUpdatedSymptoms);
    }

    getSuggestionList = (): IStaticDataValue[] => {
        if (!_isEmpty(this.props.suggestions) && !_isEmpty(this.props.suggestions[SUB_SECTIONS_CONTEXT_KEY.CHIEF_COMPLAINTS])) {
            const suggestions = this.props.suggestions[SUB_SECTIONS_CONTEXT_KEY.CHIEF_COMPLAINTS];
            if (!_isEmpty(this.props.updatedComplaints)) {
                const alreadyFilledItems = this.props.updatedComplaints.map(complaint => complaint.item.displayValue);
                return suggestions.filter((item: any) => alreadyFilledItems.indexOf(item.displayValue) < 0);
            }
            return suggestions;
        }
        return [];
    }

    onSuggestionAdd = (item: any) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedComplaints);
        currUpdatedSymptoms.push({item})
        this.props.updateComplaints(currUpdatedSymptoms);
    }

    render() {
        const suggestionList = this.getSuggestionList();
        return (
            <div className="patient-symptom-editor">
                <CustomHeader headerInfos={PhysioComplaintsEditorHeaderInfos} rootCls={"patient-symptom"}/>
                <TemplatedList templateName={"symptom"} commonProps={{ fetchSymptomByName: this.props.fetchStaticSymptoms, addSymptomForReview: this.props.addSymptomForReview }}
                               defaultItem={{item: ModelFactory.createNewSymptom()}}
                               listItems={this.props.updatedComplaints}
                               onItemRemove={this.onComplaintRemove}
                               onItemChange={this.onComplaintChange}/>
                {!_isEmpty(suggestionList) &&
                <SuggestionTagsContainer rootClass={"chief-complaints"} suggestions={suggestionList} onTagSelect={this.onSuggestionAdd} />}
            </div>
        );
    }
}

interface DispatchProps {
    addSymptomForReview: (symptomName: string) => void
}

const mapDispatchToProps = (): DispatchProps => {
    return {
        addSymptomForReview: (symptomName: string) => {
            OngoingConsultationActions.addSymptomForReview(symptomName)
        }
    }
}

export default connect(null, mapDispatchToProps)(PatientComplaintsEditor)